import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import type { Tables } from '$/database.types';

export type AdminSession = Pick<
  Tables<'decisions'>,
  'id' | 'issue_title' | 'status' | 'governance_score' | 'risk_score' | 'primary_framework' | 'created_at'
> & {
  user_email: Tables<'users'>['email'] | null;
  organization_name: Tables<'organizations'>['name'] | null;
  pending_escalation_count: number;
  has_pending_escalation: boolean;
};

async function fetchAdminSessions(): Promise<AdminSession[]> {
  const { data, error } = await supabaseClient.functions.invoke('admin-sessions', {
    method: 'GET',
  });

  if (error) throw new Error(error.message ?? 'Failed to fetch sessions');
  return (data?.data ?? []) as AdminSession[];
}

const useAdminSessions = () =>
  useQuery({
    queryKey: ['admin-sessions'],
    queryFn: fetchAdminSessions,
  });

export default useAdminSessions;
